export default defineNuxtRouteMiddleware((to) => {
  if (!useIsMergedLotteryPage(to.params.lotteryId)) return

  const localePath = useLocalePath()
  const lotteryId = String(to.params.lotteryId).toLowerCase()

  return navigateTo(localePath({ path: `/${lotteryId}`, query: to.query, hash: to.hash }), {
    replace: true,
  })
})
